import { render, staticRenderFns } from "./FormattedWeek.vue?vue&type=template&id=af9409c0&"
import script from "./FormattedWeek.vue?vue&type=script&lang=ts&"
export * from "./FormattedWeek.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports